<div class="ontario-form-group">
    <div class="header">
        <div class="centered-text">
            <h5>{{'Profile.DeleteWarning' | translate}}</h5>
        </div>
        <div class="closeButton">
            <button (click)="onCloseClick()">
                <svg class="ontario-icon" alt="">
                    <use href="#ontario-icon-close"></use>
                </svg>
            </button>
        </div>
    </div>
    <button (click)="deletePlan()" class="ontario-button ontario-button--primary">
        {{'Buttons.Confirm' | translate}}
    </button>
    <button (click)="onCloseClick()" class="ontario-button ontario-button--secondary">
        {{'Profile.Cancel' | translate}}
    </button>
</div>